import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "panel", "count", "form",
                     "totalsRow", "totalAmount", "totalDelivery", "totalGrand"]

  toggle() {
    this.updatePanel()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => (cb.checked = checked))
    this.updatePanel()
  }

  submitBulk(event) {
    const form = this.formTarget
    form.querySelectorAll('input[name="ids[]"]').forEach((el) => el.remove())

    this.selectedIds.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "ids[]"
      input.value = id
      form.appendChild(input)
    })
  }

  updatePanel() {
    const selected = this.selectedCheckboxes
    if (this.hasPanelTarget) {
      if (selected.length > 0) {
        this.panelTarget.classList.remove("hidden")
        this.countTarget.textContent = selected.length
      } else {
        this.panelTarget.classList.add("hidden")
      }
    }

    const allChecked =
      this.checkboxTargets.length > 0 &&
      this.checkboxTargets.every((cb) => cb.checked)
    this.selectAllTarget.checked = allChecked

    this.updateTotals(selected)
  }

  updateTotals(selected) {
    if (!this.hasTotalsRowTarget) return

    if (selected.length > 0) {
      let amount = 0, delivery = 0, grand = 0
      selected.forEach((cb) => {
        amount += parseFloat(cb.dataset.amount || 0)
        delivery += parseFloat(cb.dataset.delivery || 0)
        grand += parseFloat(cb.dataset.grand || 0)
      })

      this.totalAmountTarget.textContent = this.formatCurrency(amount)
      this.totalDeliveryTarget.textContent = this.formatCurrency(delivery)
      this.totalGrandTarget.textContent = this.formatCurrency(grand)
      this.totalsRowTarget.classList.remove("hidden")
    } else {
      this.totalsRowTarget.classList.add("hidden")
    }
  }

  formatCurrency(value) {
    return Math.round(value).toLocaleString("ru-RU") + " ₸"
  }

  get selectedCheckboxes() {
    return this.checkboxTargets.filter((cb) => cb.checked)
  }

  get selectedIds() {
    return this.selectedCheckboxes.map((cb) => cb.value)
  }
}
